import { Box, Divider, Typography } from '@material-ui/core';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useThemeQueries } from 'views/theme';
import { SwitchSaurus } from 'views/components/controles/switches/switch-saurus';
import { ResultadoRevendaModel } from 'model/api/gestao/relatorios/resultado-revenda-model';
import { useStyles } from '../../../accordion-revenda/components/saldo/saldo-styles';
import { RelatorioChartModel, RelatorioUnitarioChartModel, registroName } from 'model/api/gestao/relatorios/relatorio-model';
import { competenciaMesAnterior, subtrairCompetencia } from 'utils/converter-competencia';
import ChartRegistros from '../charts/chart-registros';

interface DashboardSaldoProps {
    resultadoRevenda: ResultadoRevendaModel[];
    meses: number;
}

export default function TotalRegistros({ resultadoRevenda, meses }: DashboardSaldoProps) {
    const { theme } = useThemeQueries()

    const [stacked, setStacked] = useState<boolean>(false)
    const chartContainerRef = useRef<HTMLDivElement>(null)

    const classes = useStyles({ showOverflow: meses >= 24, chartContainerRef });

    const [dadosContratos, setDadosContratos] = useState<RelatorioChartModel[]>([])

    const tratarDados = useCallback(() => {
        try {
            let arr: RelatorioChartModel[] = [
                new RelatorioChartModel('licencasQtdAberta', []),
                new RelatorioChartModel('licencasQtdBonificada', []),
                new RelatorioChartModel('licencasQtdCancelada', []),
                new RelatorioChartModel('licencasQtdPaga', []),
                new RelatorioChartModel('licencasQtdTotal', []),
            ]
            const competenciaAtual = competenciaMesAnterior();

            for (let i = 0; i <= meses; i++) {
                const competenciaSubtraida = subtrairCompetencia(competenciaAtual, i)
                const foundItem = resultadoRevenda.find(element => element.anoMes === competenciaSubtraida)
                const resultadosMes = resultadoRevenda.filter(element => element.anoMes === competenciaSubtraida)
                if (foundItem) {
                    arr = arr.map(element => {
                        const property = element.name as registroName
                        const valorSomado = resultadosMes.reduce((prev, curr) =>  {
                            return prev + curr[property]
                        }, 0)
                        element.data.push(new RelatorioUnitarioChartModel(competenciaSubtraida, valorSomado))
                        return element
                    })
                }
            }

            setDadosContratos(arr.map(item => {
                item.data = item.data.sort((a, b) => a.x - b.x)
                switch (item.name) {
                    case 'licencasQtdAberta':
                        item.name = 'Abertas'
                        break;
                    case 'licencasQtdBonificada':
                        item.name = 'Bonificadas'
                        break;
                    case 'licencasQtdCancelada':
                        item.name = 'Canceladas'
                        break;
                    case 'licencasQtdPaga':
                        item.name = 'Pagas'
                        break;
                    case 'licencasQtdFaturada':
                        item.name = 'Faturadas'
                        break;
                    case 'licencasQtdTotal':
                        item.name = 'Total'
                        break;
                }
                return item
            }))
        } catch (e) {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultadoRevenda])

    useEffect(() => {
        tratarDados()
    }, [tratarDados])


    return (
        <>
            <Box display='flex' flexDirection='column' width='100%' gridGap={theme.spacing(1)}>
                <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gridGap={5}>
                    <Typography color='primary' variant='h6'>Registros</Typography>
                    <Box display='flex' gridGap={8} alignItems='center'>
                        <Box display='flex' alignItems='center'>
                            <Typography
                                variant='caption'
                                color='textSecondary'
                            >
                                Empilhado:
                            </Typography>
                            <SwitchSaurus
                                value={stacked}
                                onChange={() => setStacked(prev => !prev)}
                                variant='LIGHT'
                            />
                        </Box>
                    </Box>
                </Box>
                <Divider />
                <div className={classes.chartContainer} ref={chartContainerRef}>
                    <ChartRegistros list={dadosContratos} stacked={stacked} width={
                        meses >= 24 ? meses * 100 : undefined
                    } />
                </div>
            </Box>
        </>
    );
}